<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#3F033B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">{{ msg }}</span>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs9 text-left pb-2>
        <span class="mainHeader">REPAIR &amp; SERVICE JOBS</span>
      </v-flex>
      <v-flex xs3 text-right>
        <v-btn dark color="#3F053C" @click="openIntakeDialog()">New Intake</v-btn>
      </v-flex>
      <v-flex xs12 py-6 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="jobList.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Customer</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Item</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Issue</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Est. Cost</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Status</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Action</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in jobList" :key="i" class="table">
                      <td>{{ value.customerId ? value.customerId.customerName : "-" }}</td>
                      <td>{{ value.itemDescription }}</td>
                      <td>{{ value.issueDescription || "-" }}</td>
                      <td>₹{{ value.estimatedCost }}</td>
                      <td>{{ value.status }}</td>
                      <td>
                        <v-select
                          v-if="value.status != 'Delivered'"
                          :value="value.status"
                          :items="['Received', 'InProgress', 'Completed']"
                          dense
                          hide-details
                          style="max-width: 140px; display: inline-block"
                          @change="updateStatus(value, $event)"
                        ></v-select>
                        <v-btn v-if="value.status == 'Completed'" x-small color="#3F053C" dark @click="openDeliverDialog(value)">Deliver</v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No repair jobs yet.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog width="500px" v-model="intakeDialog">
      <v-card width="500px" class="pa-4">
        <span style="color: #3f053c; font-size: 20px">New Repair Intake</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2>
            <v-autocomplete
              v-model="newJob.customerId"
              :items="customerOptions"
              item-text="customerName"
              item-value="_id"
              outlined
              dense
              label="Customer"
              hide-details
              @update:search-input="searchCustomer"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.itemDescription" outlined dense label="Item Description" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.issueDescription" outlined dense label="Issue / Work Needed" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.estimatedCost" type="number" outlined dense label="Estimated Cost (₹)" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-text-field v-model="newJob.expectedCompletionDate" type="date" outlined dense label="Expected Completion" hide-details></v-text-field>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="intakeDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="createIntake()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400px" v-model="deliverDialog">
      <v-card width="400px" class="pa-4" v-if="curJob">
        <span style="color: #3f053c; font-size: 20px">Deliver Item</span>
        <v-layout wrap pt-4>
          <v-flex xs12 pb-2>
            <v-text-field v-model="deliverForm.finalCost" type="number" outlined dense label="Final Cost (₹)" hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 pb-2>
            <v-checkbox v-model="deliverForm.isPaid" label="Payment received"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deliverDialog = false">Cancel</v-btn>
          <v-btn color="#3F053C" dark @click="deliverItem()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 2000,
      msg: null,
      jobList: [],
      customerOptions: [],
      intakeDialog: false,
      deliverDialog: false,
      curJob: null,
      newJob: {
        customerId: null,
        itemDescription: null,
        issueDescription: null,
        estimatedCost: null,
        expectedCompletionDate: null,
      },
      deliverForm: { finalCost: null, isPaid: false },
    };
  },
  mounted() {
    this.getJobList();
  },
  methods: {
    getJobList() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/repairjob/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.jobList = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    searchCustomer(keyword) {
      if (!keyword) return;
      axios({
        method: "get",
        url: "/customer/getlist",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { keyword: keyword, count: 10, page: 1 },
      })
        .then((response) => {
          if (response.data.status == true) {
            this.customerOptions = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openIntakeDialog() {
      this.newJob = { customerId: null, itemDescription: null, issueDescription: null, estimatedCost: null, expectedCompletionDate: null };
      this.intakeDialog = true;
    },
    createIntake() {
      axios({
        method: "post",
        url: "/repairjob/add",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: this.newJob,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.intakeDialog = false;
            this.getJobList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateStatus(job, newStatus) {
      axios({
        method: "post",
        url: "/repairjob/edit",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: job._id, status: newStatus },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          this.getJobList();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openDeliverDialog(job) {
      this.curJob = job;
      this.deliverForm = { finalCost: job.estimatedCost, isPaid: false };
      this.deliverDialog = true;
    },
    deliverItem() {
      axios({
        method: "post",
        url: "/repairjob/deliver",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: this.curJob._id, finalCost: this.deliverForm.finalCost, isPaid: this.deliverForm.isPaid },
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (response.data.status == true) {
            this.deliverDialog = false;
            this.getJobList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
